export const API_HOST = (process.env.NODE_ENV !== 'development') ? 'https://api.poirot.app/' : 'http://localhost:8081/'
export const APP_HOST = (process.env.NODE_ENV !== 'development') ? 'https://system.poirot.app/' : 'http://localhost:3000/'
export const CDN_HOST = 'https://cdn.poirot.app/'
export const SUGGEST_FEATURE_WEBHOOK = 'https://hooks.zapier.com/hooks/catch/1272343/onwuyhj'